import React from 'react';
import PropTypes from 'prop-types';

import { FiCheck } from 'react-icons/fi';
import { TITLE_BUTTON_SAVE, TITLE_BUTTON_SAVE_EN } from '../../utils/common/constant';
import Button from '../styled/button/Button';

const SaveCircleButton = ({ onAdd }) => {
  const locale = 'en';
  const buttonSave = locale === 'id' ? TITLE_BUTTON_SAVE : TITLE_BUTTON_SAVE_EN;
  return (
    <Button type="submit" aria-label={buttonSave} title={buttonSave} onClick={() => onAdd()}><FiCheck /></Button>
  );
};

SaveCircleButton.propTypes = {
  onAdd: PropTypes.func.isRequired,
};

export default SaveCircleButton;
